exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-1ae2def8] {\n  color: #231f20;\n  padding-bottom: 1px;\n  border-bottom: 3px solid #88c86f;\n  transition: all .3s ease-in-out;\n}\na[data-v-1ae2def8]:hover {\n  color: #88c86f;\n}\n", ""]);

// exports
